import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetFinanceAccountsService } from "@/features/accounts/finance/services/get-accounts-service";
import { SynchronizeAccountsService } from "@/features/accounts/finance/services/synchronize-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useGetFinanceAccountStates } from "@/features/accounts/finance/hooks/use-get-accounts-states";
import { useContext } from "react";
import { GetFinanceAccountsResponseModel } from "@/features/accounts/finance/services/get-accounts-model";
import { ErrorType } from "@/shared/config/error-type";
import { MoneyLinkException } from "@/shared/utils/custom-exception";


export const useGetFinanceAccount = () => {
  const {
    institutionType,
    setInstitutionType,
    //financeAccountId,
    //setFinanceAccountId,
    financeAccounts,
    setFinanceAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useGetFinanceAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const getFinanceAccountsService = new GetFinanceAccountsService();
  const synchronizeAccountsService = new SynchronizeAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 銀行口座一覧取得
  const getFinanceAccounts = async (
    accountGroupId: string,
    financeAccountId?: string,
    excludeUnselected?: boolean,
  ) :Promise<GetFinanceAccountsResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      let resFinanceAccounts = await getFinanceAccountsService.getFinanceAccounts({
        account_group_id: accountGroupId,
        ...(financeAccountId !== undefined && { finance_account_id: financeAccountId }),
        ...(excludeUnselected !== undefined && { exclude_unselected: excludeUnselected }),
      });
      if (financeAccountId !== undefined && resFinanceAccounts.length !== 0) {
        // 口座同期
        const isSyncBank = resFinanceAccounts[0].is_synchronize === 0 ? false : true;
        try {
          await synchronizeAccountsService.synchronizeAccounts({
            account_group_id: accountGroupId,
            finance_account_id: financeAccountId,
            is_sync_bank: isSyncBank,
          });
        } catch (error) {
          if (
            error instanceof MoneyLinkException
            && error.error.props.reason === ErrorType.REAUTH_FOR_SYNC
          ) {
            // 同期不可の場合はlinkstorageまでの同期でもう一度実行する
            await synchronizeAccountsService.synchronizeAccounts({
              account_group_id: accountGroupId,
              finance_account_id: financeAccountId,
              is_sync_bank: false,
            });
          } else {
            throw error;
          }
        }

        // 再度、銀行口座一覧取得
        resFinanceAccounts = await getFinanceAccountsService.getFinanceAccounts({
          account_group_id: accountGroupId,
          ...(financeAccountId !== undefined && { finance_account_id: financeAccountId }),
          ...(excludeUnselected !== undefined && { exclude_unselected: excludeUnselected }),
        });
      }
      // 成功時の処理
      setFinanceAccounts(resFinanceAccounts);
      return resFinanceAccounts;
    } catch (error) {
      // エラーハンドリング
      console.log("getFinanceAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    //financeAccountId,
    //setFinanceAccountId,
    institutionType,
    setInstitutionType,
    financeAccounts,
    setFinanceAccounts,
    isShowErrorDialog,
    setIsShowErrorDialog,
    getFinanceAccounts: errorHandledAsync(getFinanceAccounts, setError),
  };
};
